var _excluded = ["heading", "onClick", "sortedBy", "sortType"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Icon from "../../../basic/Icon/Icon.js";
import Tooltip from "../../../basic/Tooltip/Tooltip.js";
var StyledTableHeaderOrderableName = styled.span.withConfig({
  componentId: "CL__sc-5imkt-0"
})(["text-decoration:underline;"]);
var StyledTableHeaderOrderableIcon = styled(Icon).withConfig({
  componentId: "CL__sc-5imkt-1"
})(["margin:0 0 0 3px;"]);
export var StyledTableHeaderOrderableButton = styled.button.withConfig({
  componentId: "CL__sc-5imkt-2"
})(["display:inline-flex;align-items:center;padding:0;margin:0;background:none;border:none;width:auto;border-radius:var(--border-radius-round);cursor:pointer;transition:color var(--hover-transition);font:inherit;color:var(--text-color);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;appearance:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover{color:var(--highlight-color);}&:active{opacity:0.75;}&:focus{outline:0;}&:focus-visible{color:var(--highlight-color);}"]);
var TableItemName = _ref => {
  var {
      heading,
      onClick,
      sortedBy,
      sortType = 'numeric'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var SortedByIcon = {
    asc: IconSet.ArrowUp,
    desc: IconSet.ArrowDown
  };
  var SortTypeText = {
    alpha: {
      asc: 'A-Z',
      desc: 'Z-A'
    },
    numeric: {
      asc: 'lowest to highest',
      desc: 'highest to lowest'
    },
    time: {
      asc: 'most recent first',
      desc: 'oldest first'
    }
  };
  var getSortType = direction => {
    if (typeof sortType === 'string') {
      return SortTypeText[sortType][direction];
    }
    return sortType[direction];
  };
  var SortedByTooltip = {
    asc: "Reorder by ".concat(heading, " (").concat(getSortType('desc'), ")"),
    desc: "Reset order to default",
    unsorted: "Reorder by ".concat(heading, " (").concat(getSortType('asc'), ")")
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableHeaderOrderableButton, _extends({}, props, {
    "aria-label": sortedBy ? SortedByTooltip[sortedBy] : SortedByTooltip.unsorted,
    "data-for": "".concat(heading, "-reorder-tooltip"),
    "data-tip": true,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(StyledTableHeaderOrderableName, null, heading), sortedBy && /*#__PURE__*/React.createElement(StyledTableHeaderOrderableIcon, {
    component: SortedByIcon[sortedBy],
    size: "small"
  })), /*#__PURE__*/React.createElement(Tooltip, {
    id: "".concat(heading, "-reorder-tooltip"),
    place: "top",
    size: "small"
  }, sortedBy ? SortedByTooltip[sortedBy] : SortedByTooltip.unsorted));
};
export default TableItemName;